import { useQuery } from '@tanstack/react-query';
import { apiGet } from '../../api';

export function useShipments(enabled = true) {
  return useQuery({
    queryKey: ['shipments'],
    enabled,
    queryFn: async () => {
      try {
        const apiResult = await apiGet(`shipments?v=${Date.now()}`);
        if (apiResult.ok) {
          return apiResult.json();
        }

        throw new Error('Unable to fetch inventory');
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        return null;
      }
    },
  });
}
